import React from 'react'
import './RightSideBar.css';
const RightSideBar = () => {
  return (
    <div className="right-side-container">
          <a href="mailto:mohammedsaqibbca62@gmail.com" target='_blank' title='Mail'>mohammedsaqibbca62@gmail.com</a>
          <span></span>
      </div>
  )
}

export default RightSideBar